import { AxiosInstance } from 'axios';

import { FAIL_REPORT_URLS } from '@/constants/urls';
import { FAIL_REPORT_STATUS } from '@/model/FailReport/FailReport';
import { FailReportItem } from '@/model/FailReport/FailReportItem';

class FailReportApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  createFailReportItem = async (failReportItemData: FailReportItem) => {
    try {
      const response = await this.axiosInstance.post(
        `${FAIL_REPORT_URLS.FAIL_REPORT_ITEMS}`,
        failReportItemData,
      );

      return response.data;
    } catch (error) {
      console.error('Error creating fail report:', error);
      throw error;
    }
  };

  updateFailReportItem = async (failReportItemData: Partial<FailReportItem>) => {
    try {
      const payload: Record<string, unknown> = {};

      Object.entries(failReportItemData).forEach(([key, value]) => {
        // Backend expects missing fields as null instead of undefined
        payload[key] = value === undefined ? null : value;
      });

      const response = await this.axiosInstance.patch(
        `${FAIL_REPORT_URLS.FAIL_REPORT_ITEMS}/${failReportItemData.id}`,
        payload,
      );

      return response.data;
    } catch (error) {
      console.error('Error updating fail report item:', error);
      throw error;
    }
  };

  deleteFailReportItem = async (failReportItemData: FailReportItem) => {
    try {
      const response = await this.axiosInstance.delete(
        `${FAIL_REPORT_URLS.FAIL_REPORT_ITEMS}/${failReportItemData.id}`,
      );

      return response.data;
    } catch (error) {
      console.error('Error deleting fail report item:', error);
      throw error;
    }
  };

  async getFailReportItems(failReportId: number) {
    try {
      const response = await this.axiosInstance.get(
        `${FAIL_REPORT_URLS.FAIL_REPORT_ITEMS}?fail_report=${failReportId}`,
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  /** Actualiza el estado de un informe de falla */
  updateFailReportStatus = async (failReportId: number, status: FAIL_REPORT_STATUS) => {
    try {
      const response = await this.axiosInstance.patch(`/fail_reports/${failReportId}`, { status });

      return response.data;
    } catch (error) {
      console.error('Error updating fail report status:', error);
      throw error;
    }
  };
}

export default FailReportApi;
